import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Popper from "@mui/material/Popper";
import useClasses from "../useClasses";

const styles = (theme) => ({
  root: {
    borderRadius: theme.shape.borderRadius,
    border: "2px solid rgba(0,0,0,0)",
  },
  error: {
    borderRadius: theme.shape.borderRadius,
    border: "2px solid " + theme.palette.secondary.dark,
  },
  focused: {
    border: "2px solid " + theme.palette.primary.dark,
    borderRadius: theme.shape.borderRadius,
  },
  input: {
    fontSize: theme.typography.body2.fontSize,
    fontFamily: theme.typography.body2.fontFamily,
    fontWeight: theme.typography.body2.fontWeight,
    letterSpacing: theme.typography.body2.letterSpacing,
    padding: theme.spacing(0, 1),
  },
});

function PopperMy(props) {
  return (
    <Popper
      {...props}
      style={{ width: props.style.width }}
      placement="bottom-start"
    />
  );
}

const handleFocus = (event) => {
  //event.preventDefault();
  const { target } = event;
  const lastChar = target.value.length;
  target.focus();
  target.setSelectionRange(0, lastChar);
};

function AutocompleteInput({
  width,
  options,
  getOptionLabel,
  value,
  onChange,
  variant = "editor",
  textAlign,
  disabled = false,
  error = false,
  placeholder = "",
  isSelected,
  renderOption = undefined,
}) {
  const classes = useClasses(styles);
  const ref = React.useRef();
  const defaultProps = {
    options: options,
    renderOption: renderOption,
    getOptionLabel: getOptionLabel,
    PopperComponent: PopperMy,
    value: value,
    disableClearable: true,
    popupIcon: "",
    freeSolo: true,
    onFocus: handleFocus,
    autoHighlight: false,
    disabled: disabled,
  };
  React.useEffect(() => {
    if (isSelected && ref.current) {
      ref.current.focus();
      setTimeout(function () {
        handleFocus({ target: ref.current });
      }, 50); //select all text in any field on focus for easy re-entry. Delay sightly to allow focus to "stick" before selecting.
    }
  }, [isSelected]);
  const renderInvisibleInput = (
    <Autocomplete
      classes={{
        root: error ? classes.error : classes.root,
        focused: classes.focused,
      }}
      {...defaultProps}
      onChange={onChange}
      onInputChange={onChange}
      renderInput={(params) => (
        <TextField
          inputRef={ref}
          {...params}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            className: classes.input,
            style: { textAlignLast: textAlign },
            error: error,
            autoFocus: isSelected,
          }}
          placeholder={placeholder}
        />
      )}
    />
  );

  const renderUnderlindedInput = (
    <Autocomplete
      {...defaultProps}
      onChange={onChange}
      onInputChange={onChange}
      sx={{ width: width }}
      renderInput={(params) => (
        <TextField
          {...params}
          label=""
          variant="standard"
          InputProps={{
            ...params.InputProps,
            style: { textAlignLast: textAlign },
            error: error,
          }}
        />
      )}
    />
  );

  return variant === "scheduler"
    ? renderUnderlindedInput
    : renderInvisibleInput;
}

export default AutocompleteInput;
